export default (hash) => {
  const hasQueryString = window.location.href.indexOf("?") > -1;
  let queryString = "?" + window.location.href.split("?")[1];
  const isHash = window.location.href.indexOf(hash) > -1;
  let url = hash ? hash : "";
  if(hasQueryString){
  	url += "?" + queryString.split("?")[1];
  }
  if(!isHash){
    window.history.pushState("", "", url);
  }else if(hash == "/mais"){
    window.history.pushState("", "", url);
  }
}


// WEBPACK FOOTER //
// ./src/helpers/scrollUrl.js